import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import Toast from '../../components/common/Toast';

// Public base URL for the backend folder (where the CSV files live)
const BACKEND_URL = 'https://nisa-care.com/backend/';

const CsvDataManagement = () => {
  const [activeTab, setActiveTab] = useState('newsletter');
  const [newsletterData, setNewsletterData] = useState([]);
  const [interestData, setInterestData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [newsRes, interestRes] = await Promise.all([
        fetch(`${BACKEND_URL}get-data.php?type=newsletter`),
        fetch(`${BACKEND_URL}get-data.php?type=interest`),
      ]);
      const newsJson = await newsRes.json();
      const interestJson = await interestRes.json();
      setNewsletterData(newsJson.data || []);
      setInterestData(interestJson.data || []);
    } catch (error) {
      setToast({ show: true, message: 'Failed to load data', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleExport = (type) => {
    window.open(`${BACKEND_URL}download.php?type=${type}`, '_blank');
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <Toast
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, show: false })}
      />

      <div className="page-header mb-4">
        <h2 className="page-title">CSV Data Management</h2>
        <p className="page-subtitle">Newsletter subscribers & interest form submissions</p>
      </div>

      <div className="stat-card mb-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'newsletter' ? 'active' : ''}`}
                onClick={() => setActiveTab('newsletter')}
              >
                <i className="bi bi-envelope me-2"></i>
                Newsletter Subscribers ({newsletterData.length})
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'interest' ? 'active' : ''}`}
                onClick={() => setActiveTab('interest')}
              >
                <i className="bi bi-file-earmark-text me-2"></i>
                Interest Forms ({interestData.length})
              </button>
            </li>
          </ul>
          <button className="btn btn-primary btn-sm" onClick={() => handleExport(activeTab)}>
            <i className="bi bi-download me-1"></i> Export CSV
          </button>
        </div>

        {activeTab === 'newsletter' && (
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Email</th>
                  <th>Date</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {newsletterData.length === 0 ? (
                  <tr><td colSpan="4" className="text-center text-muted">No subscribers yet</td></tr>
                ) : (
                  newsletterData.map((item, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item.Email}</td>
                      <td>{item.Date}</td>
                      <td>{item.Time}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 'interest' && (
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Gender</th>
                  <th>Age Range</th>
                  <th>Interest Level</th>
                  <th>Topics</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {interestData.length === 0 ? (
                  <tr><td colSpan="8" className="text-center text-muted">No submissions yet</td></tr>
                ) : (
                  interestData.map((item, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item['Full Name']}</td>
                      <td>{item.Email}</td>
                      <td>{item.Gender}</td>
                      <td>{item['Age Range']}</td>
                      <td>{item['Interest Level']} ★</td>
                      <td>{item.Topics}</td>
                      <td>{item.Date}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CsvDataManagement;